export const timesheetTableCardHeight = 'calc(100vh - 12rem + 4px)';
export const timesheetTableCardHeightOnMdScreens = 'calc(100vh - 15rem + 4px)';
export const defaultTableHeight = 'calc(100vh - 20rem + 62px)';
export const attachmentsTableHeight = 'calc(100vh - 18rem - 57px)';
export const assignmentsTableHeight = 'calc(100vh - 21rem - 57px)';
